import * as THREE from 'three';

export { Scene } from './Scene.js';
export { Obstacle } from './Obstacle.js';
export { Projectile } from './Projectile.js';
export { Explosion } from './Explosion.js';
export { HealthPack } from './HealthPack.js';
export { BuyZone } from './BuyZone.js';
export { Tank } from './Tank.js';
export { Airplane } from './Airplane.js';
export { Player } from './Player.js';
export { Sniper } from './Sniper.js';
export { RocketLauncher } from './RocketLauncher.js';
export { Turret } from './Turret.js';
export { Barracks } from './Barracks.js';

// A sunlit lagoon: boats on shallow water, with island bases and jetties
export const id = 'naval';
export const icon = '🌊';
export const name = 'Naval';

export function configureRenderer(renderer) {
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.0;
  renderer.setClearColor(0x8fd3e8);
}

// Called on every entity's root object after it is built
export function prepare() {}

export const strings = {
  subtitle: 'Real-time 3D naval strategy',
  about: 'Arena Game is a real-time 3D multiplayer strategy game where two captains battle for supremacy using gunboats, seaplanes, airships, and coastal cannons.',
  units: {
    tank: 'Gunboat',
    airplane: 'Seaplane',
    super_tank: 'Ironclad',
    super_helicopter: 'Airship',
    sniper: 'Harpoon Skiff',
    rocket_launcher: 'Mortar Barge'
  },
  iconTank: '🚤',
  iconHelicopter: '🛩️',
  tanks: 'Gunboats',
  helicopters: 'Seaplanes & Airships',
  money: amount => `⚓ ${amount}`,
  notEnoughMoney: 'Not enough doubloons',
  buy: 'commission',
  waitingToSpawn: 'launching...',
  forwardBase: 'Harbour',
  turret: 'Coastal Cannon',
  barracks: 'Boathouse',
  shoot: 'Fire',
  buyClaim: 'Commission/Claim',
  bulkBuy: 'Commission a flotilla (10 units)',
  bulkBuyShort: 'Flotilla (10)',
  statTanks: 'Gunboats',
  statHelicopters: 'Seaplanes',
  statSnipers: 'Harpoon Skiffs',
  statRockets: 'Mortar Barges',
  statTurrets: 'Coastal Cannons',
  statBarracks: 'Boathouses',
  statPlayer: 'Captain'
};

// Rewording of the server's plain messages
export const messages = [
  [/Tank captured enemy base/g, 'Gunboat stormed the enemy harbour'],
  [/Need \$(\d+)/g, 'Need $1 doubloons'],
  [/money/g, 'doubloons'],
  [/Bulk purchase only available for tanks and helicopters/g, 'Flotillas are only available for gunboats and seaplanes'],
  [/Super Tank/g, 'Ironclad'],
  [/Super Helicopter/g, 'Airship'],
  [/buy zone/g, 'dock'],
  [/purchase/g, 'commission ships'],
  [/enemy turret/g, 'the enemy coastal cannon'],
  [/Turret/g, 'Coastal cannon'],
  [/turret/g, 'coastal cannon'],
  [/ a base/g, ' a harbour'],
  [/base/g, 'harbour'],
  [/Barracks/g, 'Boathouse'],
  [/barracks/g, 'boathouse']
];
